function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaccinations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vaccinations",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vaccinations") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M475.8,265.19,214.08,526.91a9.65,9.65,0,0,1-13.64.06L69.91,396.43A9.64,9.64,0,0,1,70,382.79L331.68,121.08Z",
    style: {
      fill: "#28d6e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.24,
    y: 32.77,
    width: 50.38,
    height: 284.86,
    rx: 9.69,
    ry: 9.69,
    transform: "translate(-0.45 349.31) rotate(-45)",
    style: {
      fill: "#28d6e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.44,476,32.63,592.78a17,17,0,0,1-24,0L8,592.09a17,17,0,0,1,0-24L124.78,451.3Z",
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.2,
    y: 60.14,
    width: 81.39,
    height: 138.71,
    transform: "translate(45.77 369.48) rotate(-45)",
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.3,161.72l-11,11a9.69,9.69,0,0,1-13.7,0L427.46,30.51a9.69,9.69,0,0,1,0-13.71l11-11a9.68,9.68,0,0,1,13.7,0L594.3,148A9.69,9.69,0,0,1,594.3,161.72Z",
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "mitat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.73,243l58.4,58.4c3.31,3.31.63,11.37-6,18l-.68.68c-6.62,6.62-14.68,9.31-18,6l-58.4-58.41Z",
    style: {
      fill: "#2c3560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.11,315.65l58.4,58.4c3.31,3.31.63,11.37-6,18l-.69.68c-6.62,6.62-14.67,9.31-18,6l-58.41-58.41Z",
    style: {
      fill: "#2c3560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.35,170.41l58.41,58.4c3.31,3.31.62,11.37-6,18l-.68.68c-6.62,6.62-14.68,9.3-18,6l-58.4-58.41Z",
    style: {
      fill: "#2c3560"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M532.35,264.2l-21.93,21.92a9.65,9.65,0,0,1-13.64.06l-21-21L214.08,526.91a9.65,9.65,0,0,1-13.64.06l-51-51L32.62,592.77a16.88,16.88,0,0,1-23.87.11l-.34-.34L523.61,77.33l70.17,70.17a9.66,9.66,0,0,1,0,13.65l-11,11a9.65,9.65,0,0,1-13.64.06L546.4,149.44,488.85,207l43.56,43.56A9.66,9.66,0,0,1,532.35,264.2Z",
    style: {
      opacity: 0.1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccinations);
export default __webpack_public_path__ + "static/media/vaccinations.43dd95e74ae15d1ce1205624a149634a.svg";
export { ForwardRef as ReactComponent };